var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgIcon)?_c('span',{class:[
    {
      'bg-white-grey': _vm.active && !_vm.disabled,
      'cursor-pointer hover:bg-white-grey': _vm.clickable && !_vm.disabled,
      'cursor-not-allowed opacity-50': _vm.disabled,
    },
    'inline-flex items-center content-center rounded-24 svg-icon',
    _vm.iconClass,
  ],style:(_vm.svgIconStyle),domProps:{"innerHTML":_vm._s(_vm.svgIcon)},on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }